/* eslint-disable */
import '@babel/polyfill';
import Vue from 'vue';
import '@/plugins/vuetify';
import * as firebase from 'firebase';
import router from '@/router/router';
import { store } from '@/store/store';
import App from '@/App.vue';

import AlertComp from '@/components/Alert.vue';


// Vee Form Valdation 
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);


// require('./assets/fonts/fonts.css')
require('@/assets/fonts/fonts.css');
require('@/assets/css/wew.min.css');
require('@/assets/css/main.css');

Vue.config.productionTip = false;

Vue.component('app-alert', AlertComp); // Adding a global component


const vm = new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    firebase.initializeApp({
      apiKey: 'AIzaSyBNMHkLCiKazl9oqpJEEKyh3ECT6aVDn7E',
      authDomain: 'vuefbtest.firebaseapp.com',
      databaseURL: 'https://vuefbtest.firebaseio.com',
      projectId: 'vuefbtest',
      storageBucket: 'vuefbtest.appspot.com',
    });
    //firebase.auth().onAuthStateChanged(e => {
     // console.log(e)
    //});
  },
}).$mount('#app');
